// Fix für den React-Absturz "NotFoundError: The object can not be found here"
// (removeChild) bzw. "The node before which the new node is to be inserted is
// not a child of this node" (insertBefore).
//
// Ursache in dieser App: drei <Html> (Annotation-Labels) hängt seine
// DOM-Elemente SELBST per appendChild/removeChild an den Canvas-Container und
// betreibt eine eigene React-Root. Beim Navigieren race'n Reacts Reconciling
// und drei's manuelles Entfernen — der Knoten ist dann schon weg, React ruft
// trotzdem removeChild → nativer NotFoundError → ganze App tot (schwarz).
// Trat nur im Prod-Build auf iOS-Chrome auf (Timing).
//
// Dieser Patch macht removeChild/insertBefore zu einem sicheren No-op, wenn
// der Knoten gar nicht (mehr) Kind des Elternknotens ist. Im Normalfall
// verhält es sich identisch — nur der sonst crashende Fall wird abgefangen.
// Weit verbreiteter, erprobter Workaround (bekannt u.a. vom Google-Translate-
// React-Crash).

if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (typeof console !== "undefined") {
        console.warn("removeChild: Knoten ist kein Kind dieses Elternknotens — übersprungen.", child);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (typeof console !== "undefined") {
        console.warn("insertBefore: Referenzknoten ist kein Kind dieses Elternknotens — angehängt.", referenceNode);
      }
      return this.appendChild(newNode);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
